/**
 * PlayerVOD page.
 */
import PlayerTemplate from '@components/templates/player';
import useVOD from '@components/pages/player/useVOD';

/**
 * Main page component for displaying the VOD player template.
 * Fetches and displays the player template with the current asset.
 */
export default function PlayerVODPage() {
  const props = useVOD();
  return <PlayerTemplate {...props} />;
}
